import { gql } from "@apollo/client";

export const IS_LOGGEDIN = gql`
  query {
    isLoggedin @client
  }
`